export default {
  title: "Models",
}
